<div class="popup-container p-3" [dir]="dir">
  <section-title class="mb-1">{{ title | translate }}</section-title>
  <p
    class="text-secondary mt-2"
    translate
    [innerHTML]="description"
    translate
  ></p>
  @if (confirmationImage) {
    <img [src]="confirmationImage | assets" class="confirmation-image mb-3" />
  }
  <div class="ahoy-secondary-divider m-row"></div>
  <div class="d-flex justify-content-end mt-3 gap-2">
    <button mat-stroked-button color="primary" (click)="cancel()">
      <span translate>Dismiss</span>
    </button>
    <button
      mat-flat-button
      [color]="confirmBtnColor"
      class="delete-btn"
      (click)="confirm()"
      translate
    >
      <span translate>{{ confirmBtnText }}</span>
    </button>
  </div>
</div>
